export class MasterType {
    id: number;
    code: string;
    name: string;
    state: any;
}